"use client";

import { Loader2 } from "lucide-react";

const Loader = ({ page }) => {
  const isRegisterPage = page === "register";

  return (
    <div
      role="status"
      // className={cn(
      //   "fixed left-0 z-50 flex flex-col items-center justify-center bg-white/30 backdrop-blur-sm transition-all duration-200",
      //   isRegisterPage ? "top-0 h-full w-full" : "top-0 h-full w-full",
      // )}

      style={{
        background: "rgb(255 255 255 / 30%)",
      }}
      className={`${isRegisterPage ? "top-0 h-full w-full" : "top-0 h-full w-full"} fixed left-0 z-50 flex h-full items-center justify-center bg-gray-500`}
    >
      <div className="flex flex-col items-center gap-3 rounded-lg bg-white/80 px-6 py-4">
        <Loader2
          className="text-primary h-8 w-8 animate-spin"
          style={{ strokeWidth: 3 }}
        />
      </div>
    </div>
  );
};

export default Loader;
